import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import styles from "./AlarmChecklist.module.css";
import proxy from "proxy";

const AlarmChecklist = () => {
  const [searchParams] = useSearchParams();

  const projectId = searchParams.get("projectId");
  const name = searchParams.get("name");

  const [checklistName, setChecklistName] = useState("");
  const [todos, setTodos] = useState([]);
  const [signature, setSignature] = useState("");
  const [photos, setPhotos] = useState([]);
  const [status, setStatus] = useState("pending");
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    const fetchChecklist = async () => {
      try {

        const res = await fetch(`${proxy}/api/checklist/todo?projectId=${projectId}&name=${name}`)


        const data = await res.json();

        if (data.data.values && Array.isArray(data.data.values)) {
          const formattedTodos = data.data.values.map((val) => ({
            name: val,
            checked: false,
          }));

          setTodos(formattedTodos);
        }
        // setTodos([{ ...data.data?.values, checked: false }]);
        setChecklistName(data.data.name);

      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    if (projectId) fetchChecklist();
  }, [projectId, name]);

  // Toggle checkbox
  const handleCheck = (index) => {
    const updated = [...todos];
    updated[index].checked = !updated[index].checked;
    setTodos(updated);
  };
  // ✅ Convert file → base64
  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  // Upload photos
  const handlePhotoUpload = async (e) => {
    const files = Array.from(e.target.files);

    const base64Files = await Promise.all(
      files.map(async (file) => {
        const base64 = await convertToBase64(file);
        return {
          name: file.name,
          type: file.type,
          data: base64, // 🔥 full base64 string
        };
      })
    );

    setPhotos((prev) => [...prev, ...base64Files]);
  };


  const handleSubmit = async () => {
    try {
      await fetch(`${proxy}/api/checklist/submit`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          projectId,
          signature,
          status,
          todos,
          checklistName: name,
          photos, // 🔥 base64 array
        }),
      });

      alert("Checklist submitted successfully!");
    } catch (err) {
      console.error(err);
    }
  };


  const completedCount = todos.filter((t) => t.checked).length;

  if (loading) return <div className={styles.loader}>Loading checklist...</div>;

  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>
        <h2 className={styles.title}>{checklistName}</h2>

        {/* Progress */}
        <div className={styles.progress}>
          {completedCount} / {todos.length} completed
        </div>

        {/* Checklist */}
        <div className={styles.todoWrapper}>
          <div className={styles.todoList}>
            {todos.map((item, index) => (
              <div
                key={index}
                className={`${styles.todoCard} ${item.checked ? styles.checkedCard : ""
                  }`}
                onClick={() => handleCheck(index)}
              >
                <input
                  type="checkbox"
                  checked={item.checked || false}
                  onChange={() => handleCheck(index)}
                  onClick={(e) => e.stopPropagation()}
                />

                <span>{item.name || item.label}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Signature */}
        <div className={styles.section}>
          <label>E-Signature</label>
          <input
            type="text"
            value={signature}
            onChange={(e) => setSignature(e.target.value)}
            placeholder="Enter your name"
          />
        </div>

        {/* Photos */}
        <div className={styles.section}>
          <label>Attach Photos</label>
          <input type="file" multiple onChange={handlePhotoUpload} />
        </div>

        {/* Preview */}
        <div className={styles.preview}>
          {photos.map((p, i) => (
            <img key={i} src={p.data} width={80} alt="uploaded" />
          ))}
        </div>

        {/* Status */}
        <div className={styles.status}>
          <label>Status : </label>
          <select
            value={status}
            onChange={(e) => setStatus(e.target.value)}
          >
            <option value="pending">Pending</option>
            <option value="in progress">In Progress</option>
            <option value="completed">Completed</option>
          </select>
        </div>

        {/* Submit */}
        <button
          className={styles.submitBtn}
          onClick={handleSubmit}
        >
          Submit Checklist
        </button>
      </div>
    </div>
  );
};

export default AlarmChecklist;